import { store } from '@/store'
import { isPast } from 'date-fns'

export default [
  {
    path: '/social-all',
    name: 'social-all',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-users" */ '@/components/social/socialAll.vue'
      ),
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  },
  {
    path: '/social-trip',
    name: 'social-trip',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-users" */ '@/components/social/trip.vue'
      ),
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  }

]

const guard = async function(to, from, next) {
  if ( //checkIfTokenNeedsRefresh()
    window.localStorage.getItem('token') !== null &&
    window.localStorage.getItem('tokenExpiration') !== null &&
    isPast(new Date(JSON.parse(window.localStorage.getItem('tokenExpiration')) * 1000))
  ) {
    store.dispatch('refreshToken').then(() => next())
  }else{
    return next()
  }
}
